import React, { Component } from "react";
import Button from "../../../button-classic/button-classic";
import "../../../route_code/route_code.less";
import { setItemToSessionStorage } from "Utils/sessionStorage";
import InputText from "../../../../common/components/input-text/input-text";
import Cx from "classnames";
import Select from "react-select";

class AddMannedWeighBridgeMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        weigh_bridge_port: this.props.editData ? this.props.editData.weigh_bridge_port : "",
        plant_name: this.props.editData ? this.props.editData.plant_name : "",
        plant_code: this.props.editData ? this.props.editData.plant_code : "",
        vendor: this.props.editData ? this.props.editData.vendor : "",
        wb_id: this.props.editData ? this.props.editData.wb_id : "",
        is_manned: this.props.editData ? this.props.editData.is_manned : "",
        company_id: this.props.editData ? this.props.editData.company_id: this.props.companyId,
        branch_id: this.props.editData ? this.props.editData.branch_id: this.props.branchId,
      },
    };
  }

  componentDidMount() {
    setItemToSessionStorage("previousMannedWeighBridgeData", this.props.editData);
  }

  onChangeHandler = (value, id) => {
    let { data } = this.state;
    data[id] = value;
    this.setState({ data });
  };

  onSave = () => {
    const { data } = this.state;
    this.props.onSave(data);
  };

  onUpdate = () => {
    const { data } = this.state;
    this.props.onUpdate(data);
  };


  render() {
    const { data } = this.state;
    console.log("render data",data)

    const disable = !(
      data["weigh_bridge_port"] &&
      data["plant_name"] &&
      data["plant_code"] &&
      data["vendor"]
    );

    return (
      <div className="route_code_detail">
        <div onClick={this.props.toggleAdd} className="overlay"></div>
        <div id="modal" className="modal-popup" style={{ minHeight: "600px" }}>
          <div className="pop-heading">
            {`${this.props.editData ? "Edit" : "Add"} Manned WeighBridge Master`}
          </div>
          <div className="route-detail">
            <div
              className="details-section"
              style={{ display: "flex", gap: "30px" }}
            >
 
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id={"plant_name"}
                  label="Plant Name"
                  changeHandler={(value) => this.onChangeHandler(value, "plant_name")}
                  value={data["plant_name"]}
                  required={true}
                />
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id={"plant_code"}
                  label="Plant Code"
                  changeHandler={(value) =>
                    this.onChangeHandler(value, "plant_code")
                  }
                  value={data["plant_code"]}
                  required={true}
                />
              </div>
            </div>

            <div
              className="details-section"
              style={{ display: "flex", gap: "30px", marginTop: "20px" }}
            >
              <div style={{ display: "flex", flexDirection: "column" }}>
                <InputText
                  placeholder=""
                  id={"vendor"}
                  label="Vendor"
                  changeHandler={(value) =>
                    this.onChangeHandler(value, "vendor")
                  }
                  value={data["vendor"]}
                  required={true}
                />
              </div>
              <div>
                <InputText
                  placeholder=""
                  id={"weigh_bridge_port"}
                  label="Weigh Bridge Port"
                  changeHandler={(value) =>
                    this.onChangeHandler(value, "weigh_bridge_port")
                  }
                  value={data["weigh_bridge_port"]}
                  required={true}
                />
              </div>
              
            </div>

            <div className={"button_route"} style={{ marginTop: "50px" }}>
              <Button value={"Cancel"} click={this.props.toggleAdd} />
              {!this.props.editData ? (
                <Button value={"Save"} click={this.onSave} disabled={disable} />
              ) : (
                <Button
                  value={"Update"}
                  click={this.onUpdate}
                  disabled={disable}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AddMannedWeighBridgeMaster;
